<template>
    <div id="bootom-nav" style="margin: 50px" @click="jumpTo">
      <van-image style="width: 40%;height: auto;margin: 0 auto;opacity:0.4;" class="img" :src="require('@/assets/images/home/nfclass_logo.0c4a260.png')" />
    </div>
</template>

<script>
export default {
  name: 'BottomNav',
  data () {
    return {

    };
  },
  methods: {
    jumpTo () {
      this.$router.push({ name: 'Home' });
    }
  }
};
</script>

<style scoped>

</style>